/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-06 15:26:42
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-09 14:55:34
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../app/store";
import {
  InventoryPriceBody,
  InventoryPriceImplement,
  InventoryPricePage,
  InventoryPriceParams,
  InventoryPriceRemove,
  InventoryPriceSubmit,
  InventoryPriceTovoid,
} from "../../services/InventPrice";

export const initialState = {
  PriceData: [],
  PriceTotal: 0,
  Current: 1,
  PriceDetail: [],
  PriceSeletId: 0,
};

export const InvantPriceSlice = createSlice({
  name: "InventoryPrice",
  initialState,
  reducers: {
    setPriceData(state, action) {
      state.PriceData = action.payload;
    },
    setPriceTotal(state, action) {
      state.PriceTotal = action.payload;
    },
    setPriceCurrent(state, action) {
      state.Current = action.payload;
    },
    setPriceDetaol(state, action) {
      state.PriceDetail = action.payload;
    },
    setPriceSelector(state, action) {
      state.PriceSeletId = action.payload;
    },
  },
});

export const {
  setPriceCurrent,
  setPriceData,
  setPriceDetaol,
  setPriceSelector,
  setPriceTotal,
} = InvantPriceSlice.actions;

export function getInventoryPage(params: InventoryPriceParams): RootThunk {
  return api(InventoryPricePage(params), (data: any, dispatch) => {
    dispatch(setPriceData(data.records));
    dispatch(setPriceTotal(data.total));
  });
}

export const getInventoryPageAsync = createAsyncThunk<
  void,
  InventoryPriceParams,
  RootThunkApi<void>
>("InventoryPrice/submit", async (params, api) => {
  return sendAsync(InventoryPricePage(params), api, true);
});

export function submitInventory(body: InventoryPriceBody): RootThunk {
  return (dispatch, getState, args) => {
    const current = getState().supplier.Current;
    api(InventoryPriceSubmit(body), (data: any, dispatch) => {
      dispatch(getInventoryPage({ current }));
    })(dispatch, getState, args);
  };
}

export const submitInventoryAsync = createAsyncThunk<
  void,
  InventoryPriceBody,
  RootThunkApi<void>
>("InventoryPrice/submit", async (body, api) => {
  return sendAsync(InventoryPriceSubmit(body), api, true);
});

export const TovoidInventoryAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("InventoryPrice/tovoid", async (ids, api) => {
  return sendAsync(InventoryPriceTovoid(ids), api);
});

export const ImplementInventoryAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("InventoryPrice/implement", async (ids, api) => {
  return sendAsync(InventoryPriceImplement(ids), api);
});

export const RemoveInventoryAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("InventoryPrice/remove", async (ids, api) => {
  return sendAsync(InventoryPriceRemove(ids), api);
});

export const selectPriceData = (state: RootState) =>
  state.InventoryPrice.PriceData;

export const selectPriceTotal = (state: RootState) =>
  state.InventoryPrice.PriceTotal;

export const selectPriceDetail = (state: RootState) =>
  state.InventoryPrice.PriceDetail;

export const selectPriceCurrent = (state: RootState) =>
  state.InventoryPrice.Current;

export const selectPriceId = (state: RootState) =>
  state.InventoryPrice.PriceSeletId;

export default InvantPriceSlice.reducer;
